const eventStopPropagation = e => e.stopPropagation()

export default eventStopPropagation
